document.querySelectorAll('[data-comely-mobile-rotation]').forEach((hero) => {
  const controls = hero.querySelector('.comely-hero-controls');
  const pause = hero.querySelector('[data-comely-pause]');
  const mobile = matchMedia('(max-width: 767px)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let api;
  let paused = false;
  let visible = false;
  let focusPaused = hero.matches(':focus-within');

  const updatePlayback = () => {
    if (!api) return;
    const autoplay = api.plugins()?.autoplay;
    const play = (mobile.matches || hero.hasAttribute('data-comely-desktop-rotation')) && !reduced.matches && !paused && visible &&
      !document.hidden && !focusPaused;
    if (autoplay) {
      if (play && !autoplay.isPlaying()) autoplay.play();
      if (!play) autoplay.stop();
    }
    pause.hidden = reduced.matches;
    pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
    pause.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
  };

  const updateSlides = () => {
    const selected = api.selectedScrollSnap();
    api.slideNodes().forEach((slide, index) => {
      const inactive = index !== selected;
      slide.inert = inactive;
      slide.setAttribute('aria-hidden', String(inactive));
    });
  };

  const onInit = (event) => {
    if (event.target !== hero) return;
    const nextApi = event.detail.sliderApi;
    if (!nextApi) return;
    if (api !== nextApi) {
      api = nextApi;
      api.on('select', updateSlides);
      api.on('pointerUp', () => queueMicrotask(updatePlayback));
    }
    controls.hidden = false;
    updateSlides();
    updatePlayback();
  };

  hero.addEventListener('init:slide', onInit);
  pause.addEventListener('click', () => {
    paused = !paused;
    if (!paused) focusPaused = false;
    updatePlayback();
  });
  hero.addEventListener('focusin', () => {
    focusPaused = true;
    updatePlayback();
  });
  hero.addEventListener('focusout', () => requestAnimationFrame(() => {
    focusPaused = hero.matches(':focus-within');
    updatePlayback();
  }));
  hero.addEventListener('mouseleave', () => queueMicrotask(updatePlayback));
  mobile.addEventListener('change', updatePlayback);
  reduced.addEventListener('change', updatePlayback);
  document.addEventListener('visibilitychange', updatePlayback);
  const observer = new IntersectionObserver(([entry]) => {
    visible = entry.isIntersecting;
    updatePlayback();
  });
  observer.observe(hero);
  document.addEventListener('shopify:section:unload', (event) => {
    if (!event.target.contains(hero)) return;
    observer.disconnect();
    document.removeEventListener('visibilitychange', updatePlayback);
    mobile.removeEventListener('change', updatePlayback);
    reduced.removeEventListener('change', updatePlayback);
  }, { once: true });
  customElements.whenDefined('hdt-slideshow').then(() => {
    if (!api && hero.isConnected) hero.reInit();
  });
});

